import type Lot from '../../../shared/entities/Lot';

export function sortLotsByReference(a: Lot, b: Lot) {
  if (!a.reference) return -1;
  if (!b.reference) return 1;

  const aParts = a.reference.split(/(\d+)/).map(part => {
    const num = parseInt(part);
    return isNaN(num) ? part : num;
  });

  const bParts = b.reference.split(/(\d+)/).map(part => {
    const num = parseInt(part);
    return isNaN(num) ? part : num;
  });

  for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
    if (aParts[i] === bParts[i]) continue;
    return aParts[i] < bParts[i] ? -1 : 1;
  }
  return aParts.length - bParts.length;
}
